const { on } = require("hammerjs");

(function () {
  class TopReel extends PIXI.Container {
    constructor() {
      super();

      this.topReelSymbolData;
      this.topReelSymbolSprites = [];
      this.topReelSlideAnims = [];
      this.topReelEndPositions = [];
      this.topReelStartPosition = undefined;
      this.droppingSymbols = [];
      this.gatesContainer = undefined;

      this.initialSymbolData = [{ symbols: [13, 14, 13, 8, 13] }];
      this.dropSounds = [
        "reactionWooHoo0",
        "reactionWooHoo1",
        "reactionHooray",
        "reactionYay",
      ];

      this.slideOutTweens = [];
      this.slideInTweens = [];
      this.gateOpenTween = undefined;
      this.gateCloseTween = undefined;
      this.dropTween = undefined;

      this.lastDroppedSymbol = undefined;

      this.superWildExpandPositions = [];

      this.data = undefined;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      Reflex.registerEventHandler("orientationChange", () => {
        this.onOrientationChange();
      });

      this.createMasks();
    }

    doSpin(data, spinNumber = 0) {
      const self = this;
      this.data = data;
      this.slideSymbolsOut(function () {
        self.clearTopReelData();
        self.topReelSymbolData = data;
        self.createSymbolsForSpin(spinNumber);
        self.slideSymbolsIn();
      });
    }

    createMasks() {
      // Reel mask
      this.mask = new PIXI.Graphics();
      this.mask.beginFill(0x000000, 0);
      this.mask.drawRect(-22, 0, 637, 375);
      this.mask.endFill();
      this.addChild(this.mask);

      // Gates mask
      this.gatesContainer = resourceManager.get(
        "slotContainer:reelsBorderBarsContainer"
      );
      this.gatesContainer.mask = new PIXI.Graphics();
      this.gatesContainer.mask.beginFill(0x000000, 0);
      this.gatesContainer.mask.drawRect(0, 0, 960, 375);
      this.gatesContainer.mask.endFill();
      this.gatesContainer.addChild(this.gatesContainer.mask);

      this.onOrientationChange();
    }

    onOrientationChange() {
      this.skipDrop();
    }

    clearTopReelData() {
      if (this.topReelSymbolSprites.length === 0) {
        return;
      }
      this.topReelSymbolSprites.forEach((symbol) => {
        if (resourceManager.hasResource(symbol.name)) {
          resourceManager.destroyObject(symbol.name);
        }
      });
      this.topReelSlideAnims.forEach((anim) => {
        if (resourceManager.hasResource(anim.name)) {
          resourceManager.destroyObject(anim.name);
        }
      });
      this.topReelSymbolData = [];
      this.topReelSymbolSprites = [];
      this.topReelSlideAnims = [];
      this.droppingSymbols = [];
    }

    createSymbolsForSpin(spinNumber = 0) {
      for (
        let i = 0;
        i < this.topReelSymbolData[spinNumber].symbols.length;
        i++
      ) {
        const symbolName = gameController.getSymbolFromID(
          this.topReelSymbolData[spinNumber].symbols[i]
        ).texture;

        // Create static symbol sprites
        const symbolSprite = this.getTexturePathFromSymbolName(symbolName);
        this.topReelSymbolSprites.push(
          resourceManager.createObject(
            "sprite",
            "topSymbol_" + (4 - i),
            "slotContainer:TopReel",
            {
              fileName: symbolSprite,
              anchor: 0.5,
              position: { x: 0, y: 0 },
            }
          )
        );

        // Create slide animations
        const symbolSlideAnim = this.getSlideAnimFromSymbolName(symbolName);
        this.topReelSlideAnims.push(
          resourceManager.createObject(
            "movie",
            "topSymbol_SlideAnim_" + (4 - i),
            "slotContainer:TopReel",
            {
              definition: symbolSlideAnim,
              anchor: 0.5,
              default: {
                position: { x: 0, y: 0 },
              },
              loop: false,
            }
          )
        );

        this.topReelSymbolSprites[i].position = this.topReelStartPosition;
        this.topReelSlideAnims[i].position = this.topReelStartPosition;
      }
    }

    getDropAnimFromSymbolName(name) {
      switch (name) {
        case "Wild":
          return "WildDrop";
        case "WildMultiBoost":
          return "BoostDrop";
        case "WildStacked":
          return "SuperDrop";
        case "WildEachWay":
          return "EachWayDrop";
        case "NoSymbol":
          return "NoSymbolAnim";
      }
    }

    getSlideAnimFromSymbolName(name) {
      switch (name) {
        case "Wild":
          return "WildSlide";
        case "WildMultiBoost":
          return "BoostSlide";
        case "WildStacked":
          return "SuperSlide";
        case "WildEachWay":
          return "EachWaySlide";
        case "NoSymbol":
          return "NoSymbolAnim";
      }
    }

    getTexturePathFromSymbolName(name) {
      switch (name) {
        case "Wild":
          return "Symbols/Wild/Wild_Slide/wild_slide_in_00013.png";
        case "WildMultiBoost":
          return "Symbols/Wild_Boost/Boost_Slide/wild_slide_in_boost_00013.png";
        case "WildStacked":
          return "Symbols/Wild_Super/Super_Slide/wild_slide_in_super_00013.png";
        case "WildEachWay":
          return "Symbols/Wild_Each_Way/Each_Way_Slide/wild_slide_in_each_way_00013.png";
        case "NoSymbol":
          return "Blank.png";
      }
    }

    getDropMovieFromTexturePath(name) {
      switch (name) {
        case "Symbols/Wild/Wild_Slide/wild_slide_in_00013.png":
          return "WildDrop";
        case "Symbols/Wild_Boost/Boost_Slide/wild_slide_in_boost_00013.png":
          return "BoostDrop";
        case "Symbols/Wild_Super/Super_Slide/wild_slide_in_super_00013.png":
          return "SuperDrop";
        case "Symbols/Wild_Each_Way/Each_Way_Slide/wild_slide_in_each_way_00013.png":
          return "EachWayDrop";
        case "Blank.png":
          return "NoSymbolAnim";
      }
    }

    slideSymbolsIn(instant = false) {
      this.resolver = null;
      this.promise = new Promise((resolve) => {
        this.resolver = resolve;
      });
      gameController.topRowFinished = this.promise;

      let delay = 0;
      let duration = instant ? 0 : 1.2;
      const delayInc = 0.09;
      const self = this;
      this.slideOutTweens = [];
      this.slideInTweens = [];

      //Position the symbols at the end position to display after slide in animation
      for (let i = 0; i < this.topReelSymbolSprites.length; i++) {
        const symbolSprite = this.topReelSymbolSprites[i];
        symbolSprite.position =
          this.topReelEndPositions.children[0].children[
            this.topReelSymbolSprites.length - (i + 1)
          ].transform.position;
        symbolSprite.visible = false;
      }

      // Tween the slide in animations
      for (let i = 0; i < this.topReelSlideAnims.length; i++) {
        const symbol = this.topReelSlideAnims[i];
        const symbolSprite = this.topReelSymbolSprites[i];
        const targetPos = this.topReelEndPositions.children[0].children[
              this.topReelSlideAnims.length - (i + 1)
            ].transform.position

        // Play land sound
        if (symbol.Props.definition !== "NoSymbolAnim" && duration > 0) {
          timerManager.addTimer(400, undefined, function () {
            soundManager.play("topReelLand" + Math.floor(Math.random() * 3));
          });
        }
        this.slideInTweens.push({
          movementTween: gsap.to(symbol, {
            duration: duration,
            delay: instant ? 0 : delay,
            x: targetPos.x,
            y: targetPos.y,
            ease: "back.out(1.3)",
            onComplete: function () {
              if (i >= 4) {
                if (self.resolver) {
                  self.resolver();
                  self.resolver = null;
                }
              }
            },
          }),
          playTween: gsap.to(symbol, {
            duration: delay + 0.4,
            onComplete: () =>
              instant ? symbol.gotoAndStop(0) : symbol.gotoAndPlay(0),
          }),
          visibilityTween: gsap.to(symbol, {
            duration: delay + 1.15,
            onComplete: () => {
              symbol.visible = false;
              symbolSprite.visible = true;
            },
          }),
        });
        delay += delayInc;
      }
    }

    slideSymbolsOut(callback) {
      if (
        this.topReelSymbolSprites === undefined ||
        this.topReelSymbolSprites.length === 0
      ) {
        return;
      }
      let delay = 0;
      const delayInc = 0.02;

      // Show the slide animations as we slide the symbols out
      for (let i = 0; i < this.topReelSlideAnims.length; i++) {
        const symbol = this.topReelSlideAnims[i];
        const symbolStatic = this.topReelSymbolSprites[i];
        // Delay playing the slide animation and linger on the first frame for a while
        symbol.gotoAndStop(0);
        timerManager.addTimer(400, undefined, function () {
          symbol.gotoAndPlay(0);
        });

        symbol.visible = this.droppingSymbols.includes(i) ? false : true;

        soundManager.play("reelTopSpin");

        const self = this;
        this.slideOutTweens.push(
          gsap.to([symbol, symbolStatic], {
            duration: 1,
            delay: delay,
            x: symbol.transform.position.x - 2000,
            ease: "back.in(1.3)",
            onComplete: function () {
              symbol.visible = false;
              if (i >= 4) {
                callback();
              }
            },
          })
        );
        delay += delayInc;
      }

      // Hide the symbol sprites as we play the slide out animations
      for (let i = 0; i < this.topReelSymbolSprites.length; i++) {
        const symbol = this.topReelSymbolSprites[i];
        symbol.visible = false;
      }
    }

    // TO DO: FIX SUPER WILDS
    dropSymbols(cells) {
      if (cells.length === 0) return;
      let superWildReels = [];
      // Check if any of the cells are super wilds
      for (let i = 0; i < cells.length; i++) {
        // Add to the dropping symbols array so we know which slide out animations to hide later
        if (!this.droppingSymbols.includes(cells[i].coord.reel)) {
          this.droppingSymbols.push(cells[i].coord.reel);
        }
        const topSymbol = this.topReelSymbolSprites[cells[i].coord.reel];
        const updatedSymbolOrder = gameController.getUpdatedSymbolOrder(
          cells[i].coord.reel
        );
        const targetSymbol = resourceManager.get(
          "slotContainer:reelContainer:reel" +
            cells[i].coord.reel +
            ":symbolContainer:symbol" +
            updatedSymbolOrder[cells[i].coord.offset] +
            ":symbol"
        );

        const movieName = this.getDropMovieFromTexturePath(
          topSymbol.Props.fileName
        );

        // We only want to drop 1 super wild from the top reel so we need to check if one has already been found (and dropped)
        let preventThisDrop = false;
        let isSuperWild = false;
        if (movieName === "SuperDrop") {
          if (!superWildReels.includes(cells[i].coord.reel)) {
            isSuperWild = true;
            superWildReels.push(cells[i].coord.reel);
          } else {
            this.superWildExpandPositions.push(cells[i].coord);
            preventThisDrop = true;
          }
        }

        // Get data for drop
        if (!preventThisDrop) {
          const startPosition =
            gameController.getSymbolWorldPosition(topSymbol);
          const targetPosition =
            gameController.getSymbolWorldPosition(targetSymbol);
          const duration = 0.5;

          const dropSymbol = resourceManager.createObject(
            "movie",
            "topDropSymbol_" + (4 - i),
            "slotContainer",
            {
              definition: movieName,
              anchor: 0.5,
              loop: false,
            }
          );
          this.lastDroppedSymbol = dropSymbol;
          dropSymbol.position = startPosition;
          // Delay playing the drop animation and linger on the first frame for a while
          dropSymbol.gotoAndStop(0);
          timerManager.addTimer(200, undefined, function () {
            dropSymbol.gotoAndPlay(0);
          });
          resourceManager.destroyObject(topSymbol.name);

          // Delay the drop while we open the gate
          this.openGate(cells[i].coord.reel);
          const self = this;
          timerManager.addTimer(100, undefined, function () {
            // Drop the symbol into the reel
            soundManager.play(
              self.dropSounds[
                Math.floor(Math.random() * self.dropSounds.length)
              ]
            );
            self.dropTween = gsap.to(dropSymbol, {
              duration: duration,
              y: targetPosition.y,
              ease: "back.out(1.3)",
              onComplete: function () {
                timerManager.addTimer(200, undefined, function () {
                  // if (isSuperWild) {
                  //   self.expandSuperWilds(cells);
                  // }
                  resourceManager.destroyObject(dropSymbol.name);
                });
              },
            });
          });
        }
      }
    }

    skipDrop() {
      if (this.dropTween !== undefined) this.dropTween.progress(1);
      if (this.lastDroppedSymbol !== undefined) {
        this.lastDroppedSymbol.visible = false;
      }
    }

    // Moves the red bars to make room for the symbol to drop down into the reel
    openGate(row) {
      const gate = resourceManager.get(
        "slotContainer:reelsBorderBarsContainer:reelsBorder_Bar_" + row
      );
      const startPosition = gate.transform.position.x;
      const self = this;

      this.gateOpenTween = gsap.to(gate, {
        duration: 0.25,
        x: startPosition - 126,
        onComplete: function () {
          timerManager.addTimer(200, undefined, function () {
            self.closeGate(row);
          });
        },
      });
    }

    closeGate(row) {
      const gate = resourceManager.get(
        "slotContainer:reelsBorderBarsContainer:reelsBorder_Bar_" + row
      );
      const startPosition = gate.transform.position.x;

      this.gateCloseTween = gsap.to(gate, {
        duration: 0.25,
        x: startPosition + 126,
      });
    }

    doSlamStop() {
      if (this.slideOutTweens.length > 0) {
        this.slideOutTweens.forEach((tween) => {
          tween.progress(1);
        });
      }
      if (this.slideInTweens.length > 0) {
        this.slideInTweens.forEach((tween) => {
          tween.movementTween.progress(1);
          tween.playTween.progress(1);
          tween.visibilityTween.progress(1);
        });
      }
    }

    onLayoutChange() {}

    onStakeChanged(stake) {}

    onCreditChanged(creditTask) {}

    onGameConfigEvent() {
      this.topReelStartPosition = resourceManager.get(
        "slotContainer:topReelStartPosition"
      );
      this.topReelEndPositions = resourceManager.get(
        "slotContainer:topReelEndPositions"
      );
      // Fill initial symbols with dummy data
      this.topReelSymbolData = this.initialSymbolData;
      this.createSymbolsForSpin();
      this.slideSymbolsIn(true);
      // Slam stop to prevent it playing a slide in animation
      this.doSlamStop();
    }

    doPayWinsDead(task) {}
  }

  let creator = function (json) {
    return new TopReel(json.reel);
  };

  let initialiser = function (json, TopReel) {};

  let filesRequired = function () {
    return [];
  };
  resourceManager.registerObjectType(
    "TopReel",
    creator,
    initialiser,
    filesRequired
  );
})();
